/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Localcms_Celestial_Resources_DescriptionInputs */

const en_localcms_celestial_resources_description = /** @type {(inputs: Localcms_Celestial_Resources_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse our investment guides and articles`)
};

/**
* | output |
* | --- |
* | "Browse our investment guides and articles" |
*
* @param {Localcms_Celestial_Resources_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const localcms_celestial_resources_description = /** @type {((inputs?: Localcms_Celestial_Resources_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Localcms_Celestial_Resources_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_localcms_celestial_resources_description(inputs)
});